import React from 'react';
import './works.css';
import Portfolio1 from '../../assets/portfolio-1.png';
import PythonIcon from '../../assets/python.png';
import TensorFlowIcon from '../../assets/tensorflow.png'; 

const works = () => {
    const projects = [
        {
            img: Portfolio1,
            title: "Portfolio Website",
            description: "Made my own Portfolio Website with React and Node.js",
            tools: [PythonIcon, TensorFlowIcon],
            github: "https://github.com/Nick-David1"
        },
        // Add more projects here
    ];

    return (
        <section id='works'>
            <h2 className="worksTitle">My Portfolio</h2>
            <span className="worksDesc">Here are some project I have made, more in my Github!</span>
            <div className="worksGrid">
                {projects.map((project, index) => (
                    <div key={index} className="projectCard">
                        <img src={project.img} alt={project.title} className="projectImage" />
                        <h3>{project.title}</h3>
                        <p>{project.description}</p>
                        <div className="toolsUsed">
                            {project.tools.map((tool, idx) => (
                                <img key={idx} src={tool} alt="Tool" className="toolIcon" />
                            ))}
                        </div>
                        <a href={project.github} className="projectLink">GitHub</a>
                    </div>
                ))}
            </div>
            <a href="https://github.com/Nick-David1" className="workBtn">See More</a> 
        </section>
    );
}

export default works;
